module.exports = __webpack_public_path__ + "img/sad.9cd50206.svg";